import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { PUBLIC_AND_PRIVATE_ROUTES as PUBLIC_AND_PRIVATE_ROUTES_CONSTANTS } from '../../route-constants';

const AccountSelector = lazy(() => import('@~/pages/account-selector/account-selector'));
const StudentSetup = lazy(() => import('@~/pages/student-setup/student-setup'));

export const PUBLIC_AND_PRIVATE_ROUTES: RouteObject[] = [
  {
    path: PUBLIC_AND_PRIVATE_ROUTES_CONSTANTS.ACCOUNT_SELECTOR.PATH,
    element: <AccountSelector />,
    handle: {
      pageName: PUBLIC_AND_PRIVATE_ROUTES_CONSTANTS.ACCOUNT_SELECTOR.NAME,
      isPublicAndPrivate: true,
    },
  },
  {
    path: PUBLIC_AND_PRIVATE_ROUTES_CONSTANTS.STUDENT_SETUP.PATH,
    element: <StudentSetup />,
    handle: {
      pageName: PUBLIC_AND_PRIVATE_ROUTES_CONSTANTS.STUDENT_SETUP.NAME,
      isPublicAndPrivate: true,
    },
  },
];
